function CsvRemove() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7.5" transform="rotate(-90 8 8)" stroke="#D2D0D5" />
      <path d="M5 5L11 11" stroke="#B9B7BE" />
      <path d="M11 5L5 11" stroke="#B9B7BE" />
    </svg>
  )
}

export default CsvRemove
